/**
 * DontShowAgainCheckbox — final-step affordance for onboarding tours.
 *
 * Rendered inside the final step's `content`. State is owned by the
 * surrounding TourProvider (via useTour()), so the checked value is
 * available to the provider's terminal-status mapper.
 */

import { Checkbox } from '@/components/ui/checkbox';
import { useTour } from './TourProvider';

export function DontShowAgainCheckbox() {
  const { dontShowAgain, setDontShowAgain } = useTour();

  return (
    <label className="mt-3 flex items-center gap-2 text-xs text-muted-foreground cursor-pointer select-none">
      <Checkbox
        checked={dontShowAgain}
        onCheckedChange={(next) => setDontShowAgain(next === true)}
      />
      <span>Don&apos;t show this tour again</span>
    </label>
  );
}
